"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.minLengthValidator = {
    name: 'minLength',
    validation: function (value, element, config) {
        return config.length && value ? value.length >= config.length : true;
    },
};
//# sourceMappingURL=MinLengthValidator.js.map